module.exports = __webpack_public_path__ + "static/media/anushka_naik.47a4a7a0.jpg";